import {
  fileExtensionRegex,
  StaticUploadProps,
  getMLHeaderInfo,
} from './client-file-util';
import { InputFileDetails } from '../input-file-details';
import { modalUtils } from '@/app/core/utils';
import { parseRows } from '@/app/features/products/common/components/file-selection/parsers/for-cmd-line';
import { FileUpload, FileUploadProps } from '@ssar-app/uikit';
import { acceptedExtensions, HeaderInfo } from '@ssar-app/domain';
import { Button, Icon } from '@chakra-ui/react';
import { AiOutlineInbox, AiOutlineUpload } from 'react-icons/ai/index.js';

const { Dragger } = FileUpload;

export interface ClientFileSelectorProps {
  onFileClicked: () => void;
  onFileSelected: (details: InputFileDetails) => void;
  onCancel: () => void;
  isCompact?: boolean;
  subCode: string;
  beforeUpload: (
    headersInfo: HeaderInfo,
    file?: File,
    content?: string[],
    experianFileName?: string,
    clientFileName?: string,
    totalRecords?: number,
  ) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firstRow: any;
}
export const ClientFileSelector = (props: ClientFileSelectorProps) => {
  const { isCompact, firstRow } = props;

  const getHeadersInfo = (file: File): boolean => {
    props.onFileClicked();
    const fileName = file.name;
    const extension = fileExtensionRegex.exec(fileName)?.[1]?.toLowerCase();
    if (!extension || !acceptedExtensions.includes(extension)) {
      props.onCancel();
      modalUtils.showError(
        `Only files with extensions ${acceptedExtensions} are allowed. You have selected a file with an extensions ${extension}`,
      );
    } else {
      parseRows(file, 25)
        .then(async (parseResponse) => {
          if (parseResponse.scannedRowsCount < 1) {
            throw new Error('Selected file does not have any data rows.');
          }
          firstRow.current = parseResponse.data[0];
          getMLHeaderInfo(parseResponse, file)
            .then((data) => {
              props.beforeUpload(data, file);
            })
            .catch((error) => {
              modalUtils.showError(error);
            })
            .finally(() => {
              props.onCancel();
            });
        })
        .catch((err) => {
          modalUtils.showError(err, null, props.onCancel, props.onCancel);
        });
    }
    return false;
  };

  const uploadProps: FileUploadProps = {
    ...StaticUploadProps,
    onFilesAdded: (files) =>
      files.length > 0 && getHeadersInfo(files[files.length - 1]),
  };

  return (
    <>
      {isCompact && (
        <Dragger {...uploadProps}>
          <Button
            leftIcon={<AiOutlineUpload />}
            variant='outline'
            colorScheme={'gray'}
          >
            Upload new file
          </Button>
        </Dragger>
      )}
      {!isCompact && (
        <FileUpload
          {...uploadProps}
          containerProps={{ py: 4, px: 24 }}
          uploadIcon={
            <Icon as={AiOutlineInbox} fontSize='5xl' color='primary' />
          }
          label='Click or drag file to this area to start file upload.'
        />
      )}
    </>
  );
};
